import { gql, useMutation } from '@apollo/client'

import { serviceOrdersClient } from '../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertServiceOrder($input: ServiceOrderInput) {
    upsertServiceOrder(input: $input) {
      id
    }
  }
`

export const useSaveServiceOrder = () => {
  const [request, upsertServiceOrdersState] = useMutation(MUTATION, {
    client: serviceOrdersClient
  })

  const handleRequest = async (input, params) => {
    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (!!params?.onSuccess) params.onSuccess(resp?.data?.upsertServiceOrder)
      } else {
        if (!!params?.onError) params.onError()
      }
    })
  }

  return [handleRequest, upsertServiceOrdersState]
}
